


































import Vue from 'vue'
import moment from 'moment'

import { SVGProperties } from '@/api/svg'

export default Vue.extend({
  name: 'TableViews',
  props: {
    value: Array,
  },
  data() {
    return {
      svgs: [] as SVGProperties[],
    }
  },
  methods: {
    editView(uid: string) {
      this.$router.push(`/cems/setting/view/${uid}/edit`)
    },

    getFileSize(svg: SVGProperties): string {
      if (typeof svg.fileSize == 'number') {
        return (svg.fileSize / 1024).toFixed(2) + ' kb'
      }

      return 'unknown'
    },

    formatDate(d: Date): string {
      return moment(d).format('DD MMM YYYY, HH:mm:ss')
    },
  },
  watch: {
    value: async function(val: SVGProperties[]) {
      this.svgs = val
    },
  },
  async created() {
    this.svgs = this.value as SVGProperties[]
  },
})
